import React from "react";

import PaymentStatusPage from "@is/components/PaymentStatusPage";
import { PaymentStatus } from "@is/constants";

import useManageForwardBasket from "./hooks/useManageForwardBasket";

const ForwardBasket = () => {
  useManageForwardBasket();

  return <PaymentStatusPage paymentStatus={PaymentStatus.Loading} />;
};

export default ForwardBasket;
